// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Broadcast_formContainer__UPpM3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 60rem;
  width: 100%;
}
.Broadcast_formContainer_form__ywSUp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 60%;
}
@media only screen and (max-width: 50em) {
  .Broadcast_formContainer_form__ywSUp {
    width: 100%;
  }
}
@media only screen and (max-width: 31.25em) {
  .Broadcast_formContainer_form__ywSUp {
    box-shadow: none;
  }
}

.Broadcast_beside__c6Izo {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .Broadcast_beside__c6Izo {
    grid-template-columns: 100%;
  }
}

.Broadcast_imageUpload__edY79 {
  height: 30rem;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Broadcast/Broadcast.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AADF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAAJ;AACI;EAXF;IAYI,WAAA;EAEJ;AACF;AADI;EAdF;IAeI,gBAAA;EAIJ;AACF;;AAAA;EACE,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAGF;AADE;EANF;IAOI,2BAAA;EAIF;AACF;;AADA;EACE,aAAA;EACA,WAAA;AAIF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 60rem;\n  width: 100%;\n  &_form {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    background-color: var(--color-white);\n    padding: 3rem;\n    border-radius: 2rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    width: 60%;\n    @media only screen and (max-width: $bp-800) {\n      width: 100%;\n    }\n    @media only screen and (max-width: $bp-500) {\n      box-shadow: none;\n    }\n  }\n}\n\n.beside {\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 2rem;\n\n  @media only screen and (max-width: $bp-500) {\n    grid-template-columns: 100%;\n  }\n}\n\n.imageUpload {\n  height: 30rem;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `Broadcast_formContainer__UPpM3`,
	"formContainer_form": `Broadcast_formContainer_form__ywSUp`,
	"beside": `Broadcast_beside__c6Izo`,
	"imageUpload": `Broadcast_imageUpload__edY79`
};
export default ___CSS_LOADER_EXPORT___;
